export enum DropdownCustomTemplateTypes {
  ITEM = 'item',
  SELECTED_ITEM = 'selectedItem',
  HEADER = 'header',
  FILTER = 'filter',
  FOOTER = 'footer',
  EMPTY_FILTER = 'emptyfilter',
  EMPTY = 'empty',
  GROUP = 'group',
  LOADER = 'loader',
  DROPDOWN_ICON = 'dropdownicon',
  CLEAR_ICON = 'clearicon',
  FILTER_ICON = 'filtericon',
}
